var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.siteId},[(_vm.siteContent)?_c('content-area',{attrs:{"content":_vm.siteContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }